import React from "react";
import Chatbot from "../chatbot/chatbot";
import { useTranslation } from "react-i18next";

const Featuresbanner = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="main pt-[237px] max-md:pt-[80px] max-sm:pt-[97px] relative pb-[83px] w-100 min-h-[73vh] max-xxxl:h-[100vh] max-sm:!h-[50vh]">
        <div className="banner-inner back-banner max-xxxl:h-[100vh] h-[calc(100vh_-_250px)] w-[100%] absolute top-0 z-[1] right-0"></div>
        <div className="content z-[2] relative max-xxxl:max-w-[90%]  max-w-[80%] m-auto flex flex-col justify-center items-center">
          <div>
            <h1 className="text-center text-white font-sora tracking-[-2px] leading-[90px]">
              {t("features.title")}
            </h1>
            <h1 className="text-center gradient-text font-sora tracking-[-2px] leading-[90px] max-w-[1136px] max-sm:leading-[65px]">
              {t("features.subtitle")}
            </h1>
          </div>
        </div>
      </div>
      <Chatbot />
    </>
  );
};

export default Featuresbanner;
